import { useState, useEffect } from 'react'
import { React } from "react";
import Expose from './Expose';

function checkIfImageExists(url, fallbackurl) {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = url;

        img.onload = () => resolve(url);
        img.onerror = () => resolve(fallbackurl);
        // console.log("CHECKING", url, fallbackurl);
    });
}

const ArtItem = (props) => {
    var imageurl1 = props.data.IMAGE;
    var imageurl2 = "/images/" + props.data.ID + ".jpg"
    if (props.data.YTURL) {
        const ytimage = props.data.YTURL.replace("youtu.be", "img.youtube.com/vi") + "/0.jpg"
        imageurl2 = ytimage;
    }
    const [showModal, setShowModal] = useState(false);
    const [showModalDetails, setShowModalDetails] = useState(false);
    const [imageURL, setImageURL] = useState(imageurl2)
    // use local images if available
    useEffect(() => {
        checkIfImageExists(imageurl2, imageurl1)
            .then((validurl) => {
                setImageURL(validurl);
            });
    }, [imageurl1, imageurl2]);

    const newyoutube = props.data.YTURL.replace("youtu.be", "www.youtube-nocookie.com/embed")
    const youtube =
        <div class="aspect-video w-full">
            <iframe src={newyoutube} frameborder="0" width={600} height={400} title={props.data.ID} allow="accelerometer; 
        clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen referrerPolicy='strict-origin-when-cross-origin'></iframe>
        </div>

    const handleCloseModal = () => {
        // console.log("CLOSING")
        setShowModal(false);
    };

    const sendMail = (id = undefined, title = undefined) => {
        // console.log("sendMail", id, title, id !== undefined)
        if (id !== undefined) {
            window.open('mailto:steven.athanas@gmail.com?subject=' + title + ' (' + id + ')');
        }
    };



    const Xodal = (props) => {
        // console.log('PROPS',props)
        return (
            <div onClick={handleCloseModal}>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0  z-50 outline-none focus:outline-none bg-red">
                    <div className="absolute top-5 w-auto  mx-auto max-w-sm md:max-w-2xl my-auto " style={{ maxHeight: "20%" }}>
                        {/*content*/}
                        <div className="border-1 max-h-min rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                            {/*header*/}
                            <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                                <h3 className="text-xl font-semibold">
                                    {props.data.TITLE}
                                </h3>
                                <button
                                    className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                    onClick={() => setShowModal(false)}>
                                    <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                        ×
                                    </span>
                                </button>
                            </div>
                            {/*body*/}
                            <div className="relative pl-4 pr-4 flex-auto">
                                {props.data.YTURL ? youtube :
                                    <img src={imageURL} className="" alt="" width="100%" />
                                }
                                <div >
                                    <p className="my-1 text-slate-500 text-sm leading-relaxed">
                                        {props.data.DESCRIPTION.replaceAll("?", '"')}
                                    </p>
                                    {false &&
                                        <p className=" text-slate-500 text-lg leading-relaxed">
                                            Price ${props.data.PRICE} {props.data.SOLD > 0 ? <span className="font-bold">: SOLD</span> : ""}
                                            <span className="ml-96 text-slate-300 text-xs  leading-relaxed">
                                                {props.data.ID}
                                            </span>
                                        </p>}
                                </div>
                            </div>
                            {/*footer*/}
                            <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                                <button
                                    className="text-red-500 bg-emerald-500background-transparent font-bold uppercase px-6 py-2 text-sm outline-red-800 outline-1 focus:outline-double mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => handleCloseModal()}
                                >
                                    Close
                                </button>
                                {props.data.EXPOSESLUG && <button style={{ 'height': '8.5em' }}
                                    className=" bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => { setShowModalDetails(true) }}>
                                    See more details...</button>}
                                <button
                                    style={{ 'height': '8.5em' }}
                                    className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                    type="button"
                                    onClick={() => { sendMail(props.data.ID, props.data.TITLE); handleCloseModal() }}>
                                    I want it. Contact Steven Jay...
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
            </div>)
    }

    const XodalDetails = (props) => {
        console.log('XodalDetails PROPS', props)
        return (
            <div onClick={() => setShowModalDetails(false)}>
                <div className="justify-center items-start flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                    <div
                        // stop clicks inside the white box from closing the modal
                        onClick={(e) => e.stopPropagation()}
                        className="relative w-full max-w-xl md:max-w-4xl mx-4 my-6 bg-white rounded-lg shadow-2xl border border-gray-500 max-h-[90vh] overflow-y-auto"
                        style={{ WebkitOverflowScrolling: 'touch', backfaceVisibility: 'hidden', transform: 'translate3d(0,0,0)' }}
                    >
                        <Expose data={props.data} />
                    </div>
                </div>
            </div>)
    }



    // onClick={() => {window.open("/expose/" + props.data.EXPOSESLUG)}}   


    var art = <div className="max-w-sm bg-white border-gray-200 rounded-lg shadow dark:bg-transparent dark:border-white-700 border-0 relative" >
        {showModal ? Xodal(props) : <></>}
        {showModalDetails ? XodalDetails(props) : <></>}
        {/* {showModal ? <h1>On</h1>:<h1>Off</h1>} */}
        <div className="border-white border-2" onClick={() => setShowModal(true)}>
            {/* <ModalImage small={imageurl} large={imageurl} alt={props.data.TITLE} /> */}
            <img src={imageURL} alt={props.data.TITLE} className="rounded-t-lg" />

        </div>


        <div className="p-5 ">

            <h5 className="mb-2 text-lg font-bold tracking-tight text-gray-600 dark:text-gray">{props.data.TITLE}</h5>

            <p className="mb-9 font-normal text-gray-700 dark:text-gray-900 text-sm">{props.data.DESCRIPTION}</p>

            <div className="absolute bottom-2 right-2  px-3 py-2 text-sm font-medium 
                                    text-center text-slate-600 text underline hover:text-black 
                                    border-2 rounded-lg border-gray-300"
                onClick={() => setShowModal(true)}>
                More Information...
            </div>
        </div>
    </div>



    return (art)
}



export default ArtItem;